module.exports = __webpack_public_path__ + "fonts/roboto-cyrillic-ext-400-normal.c00467dc.woff2";